<!-- preloader -->
<div class="preloader" [class.preloader-fixed]="position === 'fixed'" [hidden]="!display">
  <div class="status">
    <div class="spinner-grow avatar-sm text-primary m-2" role="status"></div>
    <div>{{ loadingText }}</div>
  </div>
</div>
